<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Préstamos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button
            v-if="puedeCrear"
            type="button"
            @click="crear"
            class="btn-primary"
          >
            <i class="fa fa-plus"></i><span>Nuevo</span>
          </button>
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportarExcel" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <div class="form-inline__title">
                Fecha
              </div>
              <div class="form-inline__content">
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="H" />
                  <span>Hoy</span>
                </label>
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="A" />
                  <span>Ayer</span>
                </label>
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="P" />
                  <span>Personalizado</span>
                </label>
                <div class="form-field" v-show="form.tipoFecha == 'P'">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker
                      id="desde"
                      v-model="form.fechaDesde"
                      locale="es"
                      only-date
                      no-label
                      noClearButton
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione fecha..."
                    />
                    <label>Desde:</label>
                  </div>
                </div>
                <div class="form-field" v-show="form.tipoFecha == 'P'">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker
                      id="hasta"
                      v-model="form.fechaHasta"
                      locale="es"
                      only-date
                      no-label
                      noClearButton
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione fecha..."
                    />
                    <label>Hasta:</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <div class="form-inline__title">Estado</div>
              <div class="form-inline__content">
                <label>
                  <input
                    v-model="form.estado"
                    type="radio"
                    value="A"
                  />
                  <span>Pendientes</span>
                </label>
                <!-- <label>
                  <input
                    v-model="form.estado" 
                    type="radio" 
                    value="M" 
                  />
                  <span>En mora</span>
                </label> -->
                <label>
                  <input
                    v-model="form.estado" 
                    type="radio" 
                    value="I" 
                  />
                  <span>Inactivos</span>
                </label>
                <label>
                  <input
                    v-model="form.estado"
                    type="radio"
                    value="P"
                  />
                  <span>Pagados</span>
                </label>
                <label>
                  <input
                    v-model="form.estado"
                    type="radio"
                    value="T"
                  />
                  <span>Todos</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="multiselect-field">
                <multiselect
                  @search-change="onSearchRutas"
                  preserve-search
                  placeholder="Busque y seleccione..."
                  selectedLabel="Seleccionado"
                  selectLabel="Presiona enter para seleccionar"
                  deselectLabel="Presiona enter para eliminar"
                  label="descripcion"
                  track-by="descripcion"
                  multiple
                  v-model="selectedRutas"
                  :options="rutas"
                  @input="inputRutas"
                ></multiselect>
                <label for="rutas">Rutas</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @search="onSearchClientes"
                  id="cliente"
                  v-model="selectedCliente"
                  @input="inputCliente"
                  placeholder="Seleccione..."
                  :options="clientes"
                  label="descripcion"
                ></v-select>
                <label for="cliente">Cliente</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select">
              <div class="select-field">
                <select v-model="form.periodo" name="periodo" id="periodo">
                  <option :value="null">Seleccione...</option>
                  <option value="D">Diario</option>
                  <option value="S">Semanal</option>
                  <option value="M">Mensual</option>
                </select>
                <label for="periodo">Período</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                v-model="form.searchP"
                id="buscar"
                placeholder="Realice una consulta..."
              >
                Consultar
              </input-field>
            </div>
          </div>
          <!-- <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <div class="form-inline__title">
                Prestamos
              </div>
              <div class="form-inline__content">
                <label>
                  <input
                    v-model="form.estado_prestamo"
                    type="radio"
                    value="A"
                  />
                  <span>Activo</span>
                </label>
                <label>
                  <input 
                    v-model="form.estado_prestamo" 
                    type="radio" 
                    value="I" />
                  <span>Inactivo</span>
                </label>
                <label>
                  <input
                    v-model="form.estado_prestamo"
                    type="radio"
                    value="T"
                  />
                  <span>Todos</span>
                </label>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <k-table
          @editar="editar"
          @eliminar="eliminarPrestamo"
          @imprimirEstadoCuenta="imprimirEstadoCuenta"
          :createButton="false"
          :deleteButton="puedeAnular"
          :editButton="puedeEditar"
          :buttons="[
            {
              title: 'Imprimir Estado de Cuenta',
              icon: 'fa fa-file-pdf-o',
              class: 'btn-success',
              event: 'imprimirEstadoCuenta'
            }
          ]"
          :path="path"
          :params="form"
          :buscarButton="false"
          ref="listaPrestamos"
          :columns="[
            {
              display: 'Cliente',
              value: 'cliente.descripcion_cliente',
            },
            {
              display: 'Ruta',
              value: 'ruta.nombre',
            },
            {
              display: 'Fecha desembolso',
              value: 'fecha_desembolso',
            },
            {
              display: 'Período',
              value: 'descripcion_periodo',
            },
            {
              display: 'Valor',
              value: 'valor',
              numeric: true,
              prefijo: '$'
            },
            {
              display: '% Interés',
              value: 'porc_interes',
            },
            {
              display: 'Crédito',
              value: 'numero_documento',
            },
            {
              display: 'Cuotas',
              value: 'cuotas',
            },
            {
              display: 'CC',
              value: 'cuotas_canceladas',
            },
            {
              display: 'CF',
              value: 'cuotas_faltantes',
            },
            {
              display: 'PD',
              value: 'pagos_dominicales',
            },
            {
              display: 'AT',
              value: 'atrasos',
            },
            {
              display: 'Saldo',
              value: 'saldo',
              numeric: true,
              prefijo: '$'
            },
            {
              display: 'Total pagado',
              value: 'total_pagado',
              numeric: true,
              prefijo: '$'
            },
            {
              display: 'Estado',
              value: 'descripcion_estado',
            },
            {
              display: 'Creador',
              value: 'creador.nombre',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      name="prestamo"
      scrollable
      reset
      adaptive
      resizable
      height="auto"
      width="65%"
      :clickToClose="false"
    >
      <prestamo
        :porcInteres="parametros ? parametros.porc_interes : 6"
        :cuotas="parametros ? parametros.cuotas : 0"
        :puedeCambiarInteres="puedeCambiarInteres"
        :prestamoId="prestamoId"
        @guardar="
          $modal.hide('prestamo');
          consultar();
        "
        @cerrar="$modal.hide('prestamo')"
      ></prestamo>
    </modal>
  </div>
</template>

<script>
import Prestamo from "./Prestamo.vue";
export default {
  components: {
    Prestamo,
  },
  props: {
    puedeCambiarInteres: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeConsultar: {
      type: Boolean,
      required: true,
    },
    puedeEditar: {
      type: Boolean,
      required: true,
    },
    puedeAnular: {
      type: Boolean,
      required: true,
    },
    puedeCrear: {
      type: Boolean,
      required: true,
    },
    parametros: {
      required: false,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      path: `${url}/prestamos/consultar/C`,
      form: {
        estado: "T",
        searchP: "",
        cliente_id: "",
        periodo: null,
        rutas_id: [],
        tipoFecha: "H",
        fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
        fechaHasta: moment(new Date()).format('YYYY-MM-DD')
      },
      prestamoId: "",
      rutas: [],
      clientes: [],
      selectedRutas: [],
      selectedCliente: null,
    };
  },
  methods: {
    eliminarPrestamo: function (prestamo) {
      swal({
        title: "¿Deseas " + 
          (prestamo.estado === "A" ? "inactivar" : "re-activar") +
          " el préstamo?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/prestamos/" + prestamo.id, {
              _method: "DELETE",
            })
            .then(({data}) => {
              const {error, msg} = data;
              if(error) {
                swal("Advertencia", msg, "warning");
              } else {
                swal(
                  "El préstamo ha sido " +
                  (prestamo.estado === "A" ? "inactivado" : "re-activado") + ".",
                  "Realizado",
                  "success"
                );
                this.consultar();
              }
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    crear: function () {
      this.prestamoId = "";
      this.$modal.show("prestamo");
    },
    editar: function (row) {
      this.prestamoId = row.id;
      this.$modal.show("prestamo");
    },
    consultar: function () {
      this.$refs.listaPrestamos.loadRows();
    },
    exportarExcel: function () {
      let urlApi = `${url}/prestamos/consultar/E${this.serialize(this.form)}`;
      window.open(urlApi, "_blank");
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    onSearchRutas: function (search) {
      const that = this;
      const xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          const json = JSON.parse(this.responseText);
          that.rutas = json;
        }
      };
      const urlApi = `${url}/search/rutas?search=${search}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    onSearchClientes: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.clientes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/clientes?search=" + search, true);
      xmlhttp.send();
    },
    inputRutas: function () {
      this.form.rutas_id.splice(0, this.form.rutas_id.length);
      this.selectedRutas.forEach((element) => {
        this.form.rutas_id.push(element.id);
      });
    },
    inputCliente: function () {
      if (this.selectedCliente != null)
        this.form.cliente_id = this.selectedCliente.id;
      else this.form.cliente_id = "";
    },
    imprimirEstadoCuenta: function (prestamo) {
      let urlApi = `${url}/prestamos/consultar/P?id=${prestamo.id}`;
      window.open(urlApi, "_blank");
    }
  },
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/ListaPrestamos.vue